<template>
  <el-table-column
    prop="status"
    label="Státusz"
    min-width="80"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-tag
        v-if="scope.row.status === 'done'"
        size="small"
        type="success"
      >
        Sikeres
      </el-tag>
      <el-tag
        v-if="scope.row.status === 'pending'"
        type="info"
        size="small"
      >
        <i class="el-icon-loading"></i> Folyamatban
      </el-tag>
      <el-tag
        v-if="scope.row.status === 'failed'"
        type="danger"
        size="small"
      >
        Hiba
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'status',
};
</script>
